import Phaser from 'phaser';

export default class QuestionMaker {
  constructor(min,max) {
    this.min = min;
    this.max = max;
  }

  getQuestion () {
    return this.getSubtractionQuestion();
  }

  getSubtractionQuestion () {
    const value = { num1: -1,num2: -1,answer: 0 };

    // one of the numbers HAS to be larger than 0, so for the first number if the min is 0, we use 1 instead
    const n1 = Phaser.Math.Between(this.min === 0 ? 1 : this.min, this.max);
    const n2 = Phaser.Math.Between(this.min, this.max);
    value.num1 = Math.max(n1,n2);
    value.num2 = Math.min(n1,n2);
    value.answer = value.num1 - value.num2;
    return value;
  }
}